<template>
  <div>
    <v-row>
      <v-col class="col-12 col-sm-6">
        <v-text-field
            filled
            v-model="project.panels"
            :error-messages="errors.panels"
            label="Quantidade de painéis"
            autocomplete="panels"
            name="panels"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-solar-panel-large"
            type="text"
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-6">
        <v-text-field
            filled
            v-model="project.power_tax"
            :error-messages="errors.power_tax"
            label="Taxa de consumo atual de energia em valor (R$)"
            autocomplete="power_tax"
            name="power_tax"
            hide-details="auto"
            placeholder=" "
            prepend-inner-icon="mdi-currency-usd"
            type="text"
            v-money
        ></v-text-field>
      </v-col>
      <v-col class="col-12 col-sm-6" style="display: flex; align-items: center; flex-direction: row">
        <v-checkbox
            v-model="contract"
            name="contract"
            hide-details="auto"
            class="mt-0"
        ></v-checkbox>
        <span class="pt-2">
          Li e aceito os termos do <a href="https://controllersolar.com.br/wp-content/uploads/2020/06/CONTRATO-DE-PRESTAÇÃO-DE-SERVIÇOS-DE-MONITORAMENTO-SOLAR-SITE.pdf" target="_blank">contrato</a>
        </span>
      </v-col>
    </v-row>
    <div
        class="mt-5 bgalpha pa-2 text-right"
    >
      <v-btn
          color="success"
          @click="projectUpdate()"
          :loading="editState"
      >
        continuar
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.projectInfo();
    this.planLoad();
  },
  data() {
    return {
      errors: [],
      editState: false,
      deleteDialog: false,
      plans: [],
      project: {},
      contract: false
    }
  },
  methods: {
    projectInfo() {
      const payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,
      };
      this.$api
      .post('/project/project.info', payload)
      .then(response => {
        if (response.data.id) {
          this.project = response.data
        }
      });
    },
    planLoad() {
      this.$api
          .get('/plan/plan.list')
          .then(response => {
            this.plans = response.data
          });
    },
    prepareDeleteDialog() {
      this.deleteDialog = true;
    },
    projectUpdate() {
      this.editState = true;

      const payload = {
        project_id: this.$route.params.project_id,
        project_uid: this.$route.params.project_uid,

        title: this.project.title,
        power_tax: this.project.power_tax.toString().replace(/[^0-9]/g,''),
        panels: this.project.panels,
        contract: this.contract
      }

      this.$api
          .post('/project.update', payload)
          .then(response => {
            this.errors = [];

            if (response.data.id) {
              this.$emit('Step', 2);
            }
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          })
          .finally(() => {
            this.editState = false;
          });
    },
  },
}
</script>

<style>
</style>
